import _defineProperty from "D:\\a\\1\\s\\fepu\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/defineProperty";
var genStyle = function genStyle(token) {
  var componentCls = token.componentCls;
  return _defineProperty({}, "".concat(componentCls, "-wrapper-rtl"), _defineProperty(_defineProperty(_defineProperty(_defineProperty({
    direction: 'rtl',
    table: {
      direction: 'rtl'
    }
  }, "".concat(componentCls, "-pagination-left"), {
    justifyContent: 'flex-end'
  }), "".concat(componentCls, "-pagination-right"), {
    justifyContent: 'flex-start'
  }), "".concat(componentCls, "-row-expand-icon"), {
    float: 'right',
    '&::after': {
      transform: 'rotate(-90deg)'
    },
    '&-collapsed::before': {
      transform: 'rotate(180deg)'
    },
    '&-collapsed::after': {
      transform: 'rotate(0deg)'
    }
  }), "".concat(componentCls, "-container"), _defineProperty({
    '&::before': {
      insetInlineStart: 'unset',
      insetInlineEnd: 0
    },
    '&::after': {
      insetInlineStart: 0,
      insetInlineEnd: 'unset'
    }
  }, "".concat(componentCls, "-row-indent"), {
    float: 'right'
  })));
};
export default genStyle;